export default __webpack_public_path__ + "static/Fabricator-590ee0ebe6447daf14664614f57e539c.png";